import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex items-center gap-3 px-3 py-2.5 bg-white border border-gray-200 rounded-lg"
};
const _hoisted_2 = { class: "flex flex-col gap-0.5 flex-1 min-w-0" };
const _hoisted_3 = { class: "text-sm font-medium text-gray-900 truncate" };
const _hoisted_4 = {
    key: 0,
    class: "text-xs text-gray-500 truncate"
};
const _hoisted_5 = ["title"];
const _hoisted_6 = ["disabled", "title"];
const _hoisted_7 = {
    key: 1,
    class: "flex flex-col gap-2.5 p-3 bg-blue-50 border border-blue-200 rounded-lg"
};
const _hoisted_8 = { class: "flex flex-wrap items-end gap-2" };
const _hoisted_9 = {
    class: "flex flex-col flex-1 min-w-0 gap-1",
    style: { "min-width": "140px" }
};
const _hoisted_10 = { class: "text-xs font-medium text-gray-600" };
const _hoisted_11 = ["placeholder"];
const _hoisted_12 = {
    class: "flex flex-col flex-1 gap-1",
    style: { "min-width": "140px" }
};
const _hoisted_13 = { class: "text-xs font-medium text-gray-600" };
const _hoisted_14 = { class: "text-gray-400" };
const _hoisted_15 = ["placeholder"];
const _hoisted_16 = { class: "flex flex-col gap-1 w-28 shrink-0" };
const _hoisted_17 = { class: "text-xs font-medium text-gray-600" };
const _hoisted_18 = { value: "FLAT" };
const _hoisted_19 = { value: "PERCENTAGE" };
const _hoisted_20 = { class: "flex flex-col w-24 gap-1 shrink-0" };
const _hoisted_21 = { class: "text-xs font-medium text-gray-600" };
const _hoisted_22 = { class: "relative" };
const _hoisted_23 = { class: "absolute text-xs text-gray-400 -translate-y-1/2 left-2 top-1/2" };
const _hoisted_24 = ["max"];
const _hoisted_25 = { class: "flex flex-wrap items-center gap-3 text-xs text-gray-600" };
const _hoisted_26 = { class: "flex flex-col gap-1" };
const _hoisted_27 = { value: "LINE_ITEM" };
const _hoisted_28 = { value: "GROUPED" };
const _hoisted_29 = { class: "text-xs text-amber-700" };
const _hoisted_30 = {
    key: 0,
    class: "flex flex-wrap gap-x-4 gap-y-0.5"
};
const _hoisted_31 = {
    key: 0,
    class: "text-xs text-red-500"
};
const _hoisted_32 = {
    key: 1,
    class: "text-xs text-red-500"
};
const _hoisted_33 = { class: "flex items-center justify-end gap-3" };
const _hoisted_34 = ["disabled"];
const _hoisted_35 = {
    key: 0,
    class: "w-3.5 h-3.5 animate-spin",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
};
import { ref, reactive, computed, watch } from "vue";
import { translateApp } from "@/i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CustomChargeRow',
    props: {
        charge: {},
        isSaving: { type: Boolean }
    },
    emits: ["save", "deleted"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const mode = ref(props.charge ? "viewing" : "creating");
        const form = reactive({
            name: "",
            description: "",
            type: "FLAT",
            amount: 0,
            display_mode: "LINE_ITEM",
            is_mandatory: true,
            compounds_percentage: true,
        });
        const touched = reactive({});
        watch(() => props.charge, (c) => {
            if (c) {
                form.name = c.name;
                form.description = c.description ?? "";
                form.type = c.type;
                form.amount = c.amount;
                form.display_mode = c.display_mode;
                form.is_mandatory = true;
                form.compounds_percentage = true;
            }
        }, { immediate: true });
        const errors = computed(() => {
            const e = {};
            if (!form.name.trim())
                e.name = translateApp("services.charges.validation.name_required");
            else if (form.name.trim().length > 60)
                e.name = translateApp("services.charges.validation.name_max");
            if (form.amount < 0)
                e.amount = translateApp("services.charges.validation.amount_non_negative");
            if (form.type === "PERCENTAGE" && form.amount > 100)
                e.amount = translateApp("services.charges.validation.percentage_max");
            return e;
        });
        const hasErrors = computed(() => (touched.name && !!errors.value.name) ||
            (touched.amount && !!errors.value.amount));
        function handleSave() {
            touched.name = true;
            touched.amount = true;
            if (Object.keys(errors.value).length > 0)
                return;
            emit("save", {
                name: form.name.trim(),
                description: form.description?.trim() || undefined,
                type: form.type,
                amount: form.amount,
                display_mode: form.display_mode,
                is_mandatory: true,
                compounds_percentage: true,
            });
            if (mode.value === "editing") {
                mode.value = "viewing";
            }
        }
        function handleCancel() {
            if (mode.value === "editing") {
                mode.value = "viewing";
                if (props.charge) {
                    form.name = props.charge.name;
                    form.description = props.charge.description ?? "";
                    form.type = props.charge.type;
                    form.amount = props.charge.amount;
                    form.display_mode = props.charge.display_mode;
                    form.is_mandatory = true;
                    form.compounds_percentage = true;
                }
            }
            else {
                emit("deleted");
            }
            Object.keys(touched).forEach((k) => delete touched[k]);
        }
        function handleDelete() {
            emit("deleted");
        }
        return (_ctx, _cache) => {
            return (mode.value === 'viewing')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.charge.name), 1),
                        (__props.charge.description)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.charge.description), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("span", {
                        class: _normalizeClass(["inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium shrink-0", __props.charge.type === 'FLAT' ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'])
                    }, _toDisplayString(__props.charge.type === "FLAT"
                        ? `$${__props.charge.amount.toFixed(2)}`
                        : `${__props.charge.amount}%`), 3),
                    _createElementVNode("button", {
                        type: "button",
                        class: "p-1 text-gray-400 transition-colors hover:text-gray-600",
                        title: _ctx.$t('services.charges.actions.edit'),
                        onClick: _cache[0] || (_cache[0] = ($event) => (mode.value = 'editing'))
                    }, [...(_cache[8] || (_cache[8] = [
                            _createElementVNode("svg", {
                                class: "w-4 h-4",
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                "stroke-width": "2",
                                stroke: "currentColor"
                            }, [
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125"
                                })
                            ], -1)
                        ]))], 8, _hoisted_5),
                    _createElementVNode("button", {
                        type: "button",
                        class: "p-1 text-red-400 transition-colors hover:text-red-600",
                        disabled: __props.isSaving,
                        title: _ctx.$t('services.charges.actions.delete'),
                        onClick: handleDelete
                    }, [...(_cache[9] || (_cache[9] = [
                            _createElementVNode("svg", {
                                class: "w-4 h-4",
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                "stroke-width": "2",
                                stroke: "currentColor"
                            }, [
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                                })
                            ], -1)
                        ]))], 8, _hoisted_6)
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("label", _hoisted_10, [
                                _createTextVNode(_toDisplayString(_ctx.$t("services.charges.labels.name")) + " ", 1),
                                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-red-500" }, "*", -1))
                            ]),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.name) = $event)),
                                type: "text",
                                maxlength: "60",
                                placeholder: _ctx.$t('services.charges.placeholders.custom_name'),
                                class: _normalizeClass(["h-8 px-2.5 text-sm bg-white border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400",
                                    touched.name && errors.value.name ? 'border-red-400' : 'border-gray-300'
                                ]),
                                onBlur: _cache[2] || (_cache[2] = ($event) => (touched.name = true))
                            }, null, 42, _hoisted_11), [
                                [_vModelText, form.name]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("label", _hoisted_13, [
                                _createTextVNode(_toDisplayString(_ctx.$t("services.charges.labels.description")) + " ", 1),
                                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("services.charges.labels.optional")), 1)
                            ]),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.description) = $event)),
                                type: "text",
                                maxlength: "255",
                                placeholder: _ctx.$t('services.charges.placeholders.optional'),
                                class: "h-8 px-2.5 text-sm bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
                            }, null, 8, _hoisted_15), [
                                [_vModelText, form.description]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("label", _hoisted_17, [
                                _createTextVNode(_toDisplayString(_ctx.$t("services.charges.labels.type")) + " ", 1),
                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-red-500" }, "*", -1))
                            ]),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((form.type) = $event)),
                                class: "h-8 px-2 text-sm bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
                            }, [
                                _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.$t("services.charges.types.flat")), 1),
                                _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.$t("services.charges.types.percentage")), 1)
                            ], 512), [
                                [_vModelSelect, form.type]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("label", _hoisted_21, [
                                _createTextVNode(_toDisplayString(_ctx.$t("services.charges.labels.amount")) + " ", 1),
                                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-red-500" }, "*", -1))
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("span", _hoisted_23, _toDisplayString(form.type === "PERCENTAGE" ? "%" : "$"), 1),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((form.amount) = $event)),
                                    type: "number",
                                    min: "0",
                                    max: form.type === 'PERCENTAGE' ? 100 : undefined,
                                    step: "0.01",
                                    class: _normalizeClass(["h-8 pl-5 pr-1.5 text-sm w-full bg-white border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400",
                                        touched.amount && errors.value.amount
                                            ? 'border-red-400'
                                            : 'border-gray-300'
                                    ]),
                                    onBlur: _cache[6] || (_cache[6] = ($event) => (touched.amount = true))
                                }, null, 42, _hoisted_24), [
                                    [
                                        _vModelText,
                                        form.amount,
                                        void 0,
                                        { number: true }
                                    ]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("label", _hoisted_26, [
                                _createTextVNode(_toDisplayString(_ctx.$t("services.charges.labels.customer_display")) + " ", 1),
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((form.display_mode) = $event)),
                                    class: "h-8 px-2 text-sm bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
                                }, [
                                    _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.$t("services.charges.display.line_item")), 1),
                                    _createElementVNode("option", _hoisted_28, _toDisplayString(_ctx.$t("services.charges.display.grouped")), 1)
                                ], 512), [
                                    [_vModelSelect, form.display_mode]
                                ])
                            ])
                        ]),
                        _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t("services.charges.labels.customer_visible_warning")), 1)
                    ]),
                    (hasErrors.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            (touched.name && errors.value.name)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(errors.value.name), 1))
                                : _createCommentVNode("", true),
                            (touched.amount && errors.value.amount)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(errors.value.amount), 1))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "text-sm text-gray-500 transition-colors hover:text-gray-700",
                            onClick: handleCancel
                        }, _toDisplayString(_ctx.$t("services.charges.actions.cancel")), 1),
                        _createElementVNode("button", {
                            type: "button",
                            class: "flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-white bg-egreen-500 rounded-md hover:bg-egreen-600 transition-colors disabled:opacity-50",
                            disabled: __props.isSaving,
                            onClick: handleSave
                        }, [
                            (__props.isSaving)
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_35, [...(_cache[13] || (_cache[13] = [
                                        _createElementVNode("circle", {
                                            class: "opacity-25",
                                            cx: "12",
                                            cy: "12",
                                            r: "10",
                                            stroke: "currentColor",
                                            "stroke-width": "4"
                                        }, null, -1),
                                        _createElementVNode("path", {
                                            class: "opacity-75",
                                            fill: "currentColor",
                                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                        }, null, -1)
                                    ]))]))
                                : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("services.charges.actions.save")), 1)
                        ], 8, _hoisted_34)
                    ])
                ]));
        };
    }
});
